import createIcon from '../../createIcon';

/**
 * @component @name VerticalSplit
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxNUgxMVYxM0gzVjE1Wk0zIDE5SDExVjE3SDNWMTlaTTMgMTFIMTFWOUgzVjExWk0zIDVWN0gxMVY1SDNaTTEzIDVIMjFWMTlIMTNWNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VerticalSplit = createIcon('VerticalSplit', [
  [
    'path',
    {
      d: 'M3 15H11V13H3V15ZM3 19H11V17H3V19ZM3 11H11V9H3V11ZM3 5V7H11V5H3ZM13 5H21V19H13V5Z',
      key: '13qlvq',
    },
  ],
]);

export default VerticalSplit;
